import { render, staticRenderFns } from "./top-earners.vue?vue&type=template&id=43b2ff57&"
import script from "./top-earners.vue?vue&type=script&lang=js&"
export * from "./top-earners.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports